// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__bQe0h","icon":"Item_icon__3p256","title":"Item_title__3iscN","content":"Item_content__28C91"};